export default __webpack_public_path__ + "static/media/icon_select.151c97a2.svg";